export const formatIndianUnits = (num) => {
  if (typeof num !== "number" || isNaN(num)) return "";

  const absNum = Math.abs(num);

  let formatted = "";
  if (absNum >= 1e9) {
    formatted = (num / 1e7).toFixed(2).replace(/\.00$/, "") + " Cr";
  } else if (absNum >= 1e7) {
    formatted = (num / 1e7).toFixed(1).replace(/\.0$/, "") + " Cr";
  } else if (absNum >= 1e5) {
    formatted = (num / 1e5).toFixed(1).replace(/\.0$/, "") + " Lakh";
  } else if (absNum >= 1e3) {
    formatted = num.toLocaleString("en-IN");
  } else {
    formatted = num.toString();
  }

  return formatted;
};